import styled from "styled-components";

const CHECKBOX_SIZE = 24;
const CHECKBOX_HEIGHT = CHECKBOX_SIZE;
const CHECKBOX_WIDTH = CHECKBOX_SIZE;

// WRAPPERS
export const TopicWrapper = styled.div`
  margin-bottom: 15px;
  text-align: left;
`;

export const TopicLeftWrapper = styled.div`
  align-items: left;
`;

export const TopicRightWrapper = styled.div`
  text-align: right;
  @media (max-width: 768px) {
    text-align: left;
    margin-left: 32px; // aligns with checkbox on the left
  }
  & span:last-child {
    margin: 0;
  }
}
`;

// ----
// Components
// ----
type CheckboxProps = {
  studied: boolean;
  isDisabled: boolean;
  isBooked: boolean;
};
export const Checkbox = styled.span<CheckboxProps>`
  font-size: 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  height: ${CHECKBOX_HEIGHT}px;
  width: ${CHECKBOX_WIDTH}px;
  background-color: ${({ studied, isDisabled, isBooked }) =>
    isDisabled || (!studied && !isBooked) ? "#f6f6f6" : "#d3e8ff"};
  border: 2px solid
    ${({ studied, isDisabled, isBooked }) =>
      isDisabled || (!studied && !isBooked) ? "#707070" : "#1070B6"};
  border-radius: 2px;
`;

type TopicTitleProps = {
  studied: boolean;
  isBooked: boolean;
  isDisabled: boolean;
  skipped: boolean;
};
export const TopicTitle = styled.label<TopicTitleProps>`
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.45px;
  color: #707070;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: ${({ skipped, studied, isBooked }) =>
    skipped && !(studied || isBooked) ? "line-through" : "initial"};

  &:hover ${Checkbox} {
    background-color: ${({ isDisabled, studied }: TopicTitleProps) =>
      isDisabled || !studied ? "#ccc" : "#b8daff"};
  }
`;

type CheckmarkProps = {
  isDisabled: boolean;
  index: number;
  total: number;
};
const calculateTranslateYCheckmark = (index: number, total: number): number => {
  const start = 0;
  const end = total - 1;
  const middle = start + (end - start) / 2;

  const translateY = (index - middle) * CHECKBOX_HEIGHT;

  return translateY;
};
export const Checkmark = styled.span<CheckmarkProps>`
  color: ${({ isDisabled }) => (isDisabled ? "#707070" : "#1070B6")};
  position: relative;
  font-weight: bold;
  font-size: 20px;
  margin: 0 auto;
  bottom: ${({ index, total }) => calculateTranslateYCheckmark(index, total)}px;
`;

export const Crossmark = styled.span`
  color: #707070;
  position: relative;
  font-weight: bold;
  font-size: 20px;
  margin: 0 auto;
`;

type TopicCityTagProps = {
  isDisabled: boolean;
  isBooked: boolean;
};
export const TopicCityTag = styled.span<TopicCityTagProps>`
  height: 16px;
  width: 16px;
  background-color: ${({ isDisabled, isBooked }) =>
    isDisabled && !isBooked ? "#b4b4b4" : "#1070B6"};
  border-radius: 2px;
  letter-spacing: 0.8px;
  margin: 4px;
  padding: 4px;
  font-size: 8px;
  font-weight: bold;
  color: #ffffff;
`;

export const TopicCalendarTag = styled.span`
  height: 16px;
  width: 16px;
  background-color: #d3e8ff;
  border-radius: 2px;
  letter-spacing: 0.8px;
  margin: 4px;
  padding: 4px;
  font-size: 8px;
  font-weight: bolder;
  color: #1070b6;
`;

type TopicCategoryTagProps = {
  isDisabled: boolean;
  isBooked: boolean;
};
export const TopicCategoryTag = styled.span<TopicCategoryTagProps>`
  height: 16px;
  width: 16px;
  background-color: ${({ isDisabled, isBooked }) =>
    isDisabled && !isBooked ? "#b4b4b4" : "#1070B6"};
  border-radius: 2px;
  letter-spacing: 0.8px;
  margin: 4px;
  padding: 4px;
  font-size: 8px;
  font-weight: bold;
  color: #ffffff;
`;

export const Badge = styled.span`
  position: absolute;
  top: -10px;
  right: -10px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: #1070b6;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
